import React from "react";
import styled from "styled-components";
import responsiveRangeProps from "./responsiveRangeProps";
import mediaQueries from "../../utils/mediaQueries";

const Container = styled.div`
    ${({display}) =>
        mediaQueries({
            display,
        })}
`;

export const mapDisplayProp = ({values, display}) => {
    const [hiddenOnMobile, hiddenOnTablet, hiddenOnDesktop] = values;
    const value = [
        hiddenOnMobile ? "none" : display,
        hiddenOnTablet ? "none" : display,
        hiddenOnDesktop ? "none" : display,
    ];
    return value;
};

export default function Hidden({above, below, inline, children}) {
    const responsiveValues = responsiveRangeProps({above, below});
    const display = inline ? "inline" : "block";
    const value = mapDisplayProp({values: responsiveValues, display});

    return <Container display={value}>{children}</Container>;
}
